module.exports = __webpack_public_path__ + "img/about_banner.54ebcd2d.png";